import React, { useState, useEffect } from 'react';
import { workshopsAPI } from '../lib/api';
import { VideoCard } from '../components/VideoCard';
import { Loader2 } from 'lucide-react';
import { WorkshopsPageSEO } from '../components/SEO';

export const WorkshopsPage = () => {
    const [workshops, setWorkshops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchWorkshops = async () => {
            try {
                const response = await workshopsAPI.getAll();
                // Handle paginated response
                setWorkshops(response.data.data || response.data);
            } catch (err) {
                setError('Failed to load painting videos');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchWorkshops();
    }, []);

    if (loading) {
        return (
            <>
                <WorkshopsPageSEO />
                <div className="min-h-[50vh] flex items-center justify-center" data-testid="workshops-loading">
                    <Loader2 className="h-8 w-8 animate-spin text-accent" />
                </div>
            </>
        );
    }

    return (
        <div className="section-gap" data-testid="workshops-page">
            <WorkshopsPageSEO />
            <div className="container-main">
                {/* Header */}
                <div className="mb-12">
                    <span className="text-xs font-semibold uppercase tracking-widest text-accent">
                        Single demonstrations
                    </span>
                    <h1 className="font-serif text-4xl md:text-5xl font-semibold text-primary mt-2">
                        Oil Painting Videos & Workshops
                    </h1>
                    <p className="text-muted-foreground mt-4 max-w-2xl">
                        Watch master artists create complete paintings from start to finish. 
                        Alla prima oil painting, portrait demonstrations, and landscape sessions from professional instructors.
                    </p>
                </div>

                {error && (
                    <div className="text-center py-12" data-testid="workshops-error">
                        <p className="text-destructive">{error}</p>
                    </div>
                )}

                {!error && workshops.length === 0 && (
                    <div className="text-center py-12" data-testid="workshops-empty">
                        <p className="text-muted-foreground">No painting videos available at this time.</p>
                    </div>
                )}

                {/* Workshop Grid */}
                {workshops.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="workshops-grid">
                        {workshops.map((workshop) => (
                            <VideoCard 
                                key={workshop.id} 
                                video={workshop} 
                                type="workshop" 
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkshopsPage;
